exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".console-output-tabs {\n  list-style: none;\n  overflow-x: scroll;\n  padding: 0 20px;\n}\n.console-output-tab {\n  min-width: 50px;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

